import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Registered from '@/views/Registered'
import RegistrationSuccess from '@/views/RegistrationSuccess'
import ExpertTeam from '@/views/ExpertTeam'
import RaceIntroduction from '@/views/RaceIntroduction'
import PreliminaryApply from '@/views/PreliminaryApply'
import WorksAudit from '@/views/WorksAudit'
import AboutCompetition from '@/views/AboutCompetition'
import MediaCenter from '@/views/MediaCenter'
import Trends from '@/views/Trends'
import Detail from '@/views/Detail'
import ImageDetail from '@/views/ImageDetail'
import Images from '@/views/Images'
import videos from '@/views/videos'
import news from '@/views/news'
import RaceInformation from '@/views/RaceInformation'
import WorksDeclare from '@/views/WorksDeclare'
import myHome from '@/views/my/home'
import PastReview from '@/views/PastReview'
import Phone from '@/views/Phone'
import CampusRegistration from '@/views/CampusRegistration'
import ExpertRating from '@/views/ExpertRating'
import WorkRating from '@/views/WorkRating'
import WorkDetail from '@/views/WorkDetail'
import WorkDetailAll from '@/views/WorkDetailAll'
import Contact from '@/views/Contact'
import Information from '@/views/Information.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/registered',
    name: 'Registered',
    component: Registered
  },
  {
    path: '/registrationSuccess',
    name: 'RegistrationSuccess',
    component: RegistrationSuccess
  },
  {
    path: '/expertTeam',
    name: '专家团队',
    component: ExpertTeam
  },
  {
    path: '/raceIntroduction',
    name: '赛事介绍',
    component: RaceIntroduction
  },
  {
    path: '/preliminaryApply',
    name: '初赛',
    meta: {
      requireAuth: true
    },
    component: PreliminaryApply
  },
  {
    path: '/worksAudit',
    name: '作品审核',
    component: WorksAudit
  },
  {
    path: '/aboutCompetition',
    name: '关于大赛',
    component: AboutCompetition
  },
  {
    path: '/trends',
    name: '通知公告',
    component: Trends
  },
  {
    path: '/detail',
    name: '通知公告详情',
    component: Detail
  },
  {
    path: '/imageDetail',
    name: '图集',
    component: ImageDetail
  },
  {
    path: '/raceInformation',
    name: '赛事资讯',
    component: RaceInformation
  },
  {
    path: '/worksDeclare',
    name: '作品申报',
    meta: {
      requireAuth: true // 配置此条，进入页面前判断是否需要登陆
    },
    component: WorksDeclare
  },
  {
    path: '/myHome',
    name: 'myHome',
    meta: {
      requireAuth: true
    },
    component: myHome
  },
  {
    path: '/pastReview',
    name: '往届回顾',
    component: PastReview
  },
  {
    path: '/phone',
    name: 'Phone',
    component: Phone
  },
  {
    path: '/campusRegistration',
    name: '校园初赛报名信息',
    meta: {
      requireAuth: true
    },
    component: CampusRegistration
  },
  {
    path: '/expertRating',
    name: '成绩看板',
    component: ExpertRating
  },
  {
    path: '/workRating',
    name: '作品评分',
    component: WorkRating
  },
  {
    path: '/workDetail',
    name: '作品详情',
    component: WorkDetail
  },
  {
    path: '/images',
    name: '精彩瞬间详情',
    component: Images
  },
  {
    path: '/mediaCenter',
    name: '媒体中心',
    component: MediaCenter
  },
  {
    path: '/videos',
    name: '视频播放',
    component: videos
  },
  {
    path: '/news',
    name: '赛事新闻',
    component: news
  },
  {
    path: '/workDetailAll',
    name: '专家评审作品详情',
    component: WorkDetailAll
  },
  {
    path: '/contact',
    name: '分赛区联系方式',
    component: Contact
  },
  {
    path: '/dszx',
    name: '大赛资讯',
    component: Information
  }],
  mode: 'history' // 去掉url中的#
})



// WEBPACK FOOTER //
// ./src/router/index.js